<template>
  <div class="root">
    <ChangeCompany :hide="true"/>
    <div class="invoice-header">
      <div v-if="this.$route.meta.withGoBack" class="iconfont back" @click="goBack">&#xe682;</div>
      <div class="invoice-title">{{this.$route.name}}</div>
    </div>
    <div class="invoice-main" ref="layout">
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <Footer @pathChange="historyOnChange" />
    <BottomCube/>
  </div>
</template>

<script>
import Footer from '@components/Footer/Footer.vue'
import ChangeCompany from '@components/ChangeCompany'
import BottomCube from '@components/BottomCube'
export default {
  data: () => {
    return {
    }
  },
  mounted () {
    this.historyOnChange()
  },
  computed: {
  },
  watch: {
    $route (to, from) {
      if (to.meta.keepAlive && to.path !== from.path) {
        this.$router.go(0)
      }
    }
  },
  methods: {
    historyOnChange (item) {
      if (item) {
        this.title = item.title || ''
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    changeTitle (title) {
      this.title = title
    }
  },
  components: {
    Footer,
    ChangeCompany,
    BottomCube
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
